import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";

import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";

import PageHeader from "../../components/controls/pageHeader";
import Controls from "../../components/controls/Controls";
import useTable from "../../components/useTable";
import { baseUrl } from "../../config/const";

const COLLECTION_SUMMARY_API =
  `https://notoputrooffice.com/api/analytics/collection-summary`;


const categories = [
  { id: "ALL", name: "All" },
  { id: "Anak", name: "Anak" },
  { id: "Pria", name: "Pria" },
  { id: "Wanita", name: "Wanita" },
  { id: "Pollux", name: "Pollux" },
  { id: "Sport", name: "Sports" },
  { id: "Harian", name: "Harian" },
  // { id: "Aksesoris", name: "Aksesoris" },
];

const headCells = [
  {
    id: "collection",
    label: "Collection",
    disableSorting: true,
  },
  {
    id: "collectionStatus",
    label: "Status",
    disableSorting: true,
  },
  {
    id: "collectionSales365",
    label: "Sales 365",
    disableSorting: true,
  },
  {
    id: "collectionMomentumRatio",
    label: "Momentum",
    disableSorting: true,
  },
  {
    id: "heroDependency",
    label: "Hero",
    disableSorting: true,
  },
  {
    id: "activeSkuRatio",
    label: "Active SKU %",
    disableSorting: true,
  },
  {
    id: "totalSku",
    label: "Total SKU",
    disableSorting: true,
  },
//   {
//     id: "actions",
//     label: "Actions",
//     disableSorting: true,
//   },
];


const normalizeRows = (payload) => {

  const rows =
    payload?.results || [];

  return rows.map((item, index) => ({

    id:
      item.collection ||
      index,

    collection:
      item.collection,

    collectionStatus:
      item.collectionStatus,

    collectionSales365:
      item.collectionSales365,

    collectionMomentumRatio:
      item.collectionMomentumRatio,

    heroDependency:
      item.heroDependency,

    activeSkuRatio:
      item.activeSkuRatio,

    healthySku:
      item.healthySku,

    survivingSku:
      item.survivingSku,

    deadSku:
      item.deadSku,

    totalSku:
      item.totalSku,

    raw:
      item,

  }));
};

export default function CollectionSummary() {

  const history =
    useHistory();

  const [loading, setLoading] =
    useState(false);

  const [kategori, setKategori] =
    useState("Wanita");

  const [toko, setToko] =
    useState("ALL");

  const [rows, setRows] =
    useState([]);

  const [listToko, setListToko] = useState([]);


//   const [selectedCollection, setSelectedCollection] =
//     useState(null);

//   const [openDetail, setOpenDetail] =
//     useState(false);

  const {

    TblHead,

    TblContainer,

    TblPagination,

    recordsAfterPagingAndSorting,

  } = useTable(

    rows,

    headCells,

    {

      fn: (items) => items,

    }

  );

    // =========================
  // FETCH COLLECTION SUMMARY
  // =========================

  const getCollectionSummary =
    async () => {

      try {

        setLoading(true);

        const { data } =
          await axios.get(
            COLLECTION_SUMMARY_API,
            {
              params: {

                toko,

                kategori,

              },
            }
          );

        setRows(
          normalizeRows(data)
        );

      } catch (err) {

        console.error(err);

      } finally {

        setLoading(false);

      }
    };

 const getListToko = async () => {
    try {
      const {
        data: { data },
      } = await axios.get(`${baseUrl}/getAllToko`);

      const mappedStores = (data || []).map((store) => ({
        id: store.name,
        name: store.name,
      }));

      setListToko([{ id: "ALL", name: "ALL" }, ...mappedStores]);
    } catch (err) {
      console.error(err);
      setListToko([{ id: "ALL", name: "ALL" }]);
    }
  };    

  // =========================
  // INITIAL LOAD
  // =========================

  useEffect(() => {

    getCollectionSummary();

  }, [

    toko,

    kategori,

  ]);

 useEffect(() => {
    getListToko();
  }, []);  

  

  // =========================
  // SUMMARY
  // =========================

  const summary =
    useMemo(() => {

      return {

        total:

          rows.length,

        healthy:

          rows.filter(
            (x) =>
              x.collectionStatus ===
              "HEALTHY"
          ).length,

        rising:

          rows.filter(
            (x) =>
              x.collectionStatus ===
              "RISING"
          ).length,

        stable:

          rows.filter(
            (x) =>
              x.collectionStatus ===
              "STABLE"
          ).length,

        declining:

          rows.filter(
            (x) =>
              x.collectionStatus ===
              "DECLINING"
          ).length,

        dead:

          rows.filter(
            (x) =>
              x.collectionStatus ===
              "DEAD"
          ).length,

      };

    }, [

      rows,

    ]);

  // =========================
  // DETAIL
  // =========================

//   const openDetailDialog =
//     (row) => {

//       setSelectedCollection(
//         row
//       );

//       setOpenDetail(
//         true
//       );
//     };

//   const closeDetailDialog =
//     () => {

//       setOpenDetail(
//         false
//       );

//       setSelectedCollection(
//         null
//       );
//     };

  // =========================
  // FORMATTER
  // =========================

  const formatNumber =
    (value) => {

      return Number(
        value || 0
      ).toLocaleString(
        "id-ID"
      );
    };

  const formatRatio =
    (value) => {

      if (
        value === null ||
        value === undefined
      ) {

        return "-";

      }

      return Number(
        value
      ).toFixed(2);
    };

  // =========================
  // OPEN MOMENTUM
  // =========================

const openMomentum =
  (collection) => {

    history.push({
      pathname: "/analytics/momentum",
      state: {
        collection,
      },
    });

};

  return (
    <Box>

      <PageHeader
        title="Collection Summary"
        subTitle="Analyze Collection Performance"
      />

      <Divider
        style={{
          marginTop: 10,
          marginBottom: 20,
        }}
      />

      {/* ========================= */}
      {/* FILTER */}
      {/* ========================= */}

      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginBottom: 20,
        }}
      >

        <Toolbar
          style={{
            padding: 0,
          }}
        >
          <Controls.Label
            label="Store:"
          />

          <Controls.Select
            noNone
            value={toko}
            onChange={(e) =>
              setToko(e.target.value)
            }
            otherStyle={{
              marginBottom: 0,
              marginLeft: 10,
            }}
            options={listToko}
          />
        </Toolbar>

        <Toolbar
          style={{
            padding: 0,
          }}
        >
          <Controls.Label
            label="Category:"
          />

          <Controls.Select
            noNone
            value={kategori}
            onChange={(e) =>
              setKategori(e.target.value)
            }
            otherStyle={{
              marginBottom: 0,
              marginLeft: 10,
            }}
            options={categories}
          />
        </Toolbar>

      </Box>
    
      {/* ========================= */}
      {/* SUMMARY + TABLE */}
      {/* ========================= */}

      {loading ? (
        <Paper
          style={{
            width: "100%",
            minHeight: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <CircularProgress size={50} />

          <Typography
            style={{
              marginTop: 20,
              color: "#777",
            }}
          >
            Loading Collection Summary...
          </Typography>
        </Paper>
      ) : (
        <>
          {/* ========================= */}
          {/* SUMMARY */}
          {/* ========================= */}

          <Grid
            container
            spacing={2}
            style={{
              marginBottom: 20,
            }}
          >
            {[
              {
                title: "Collections",
                value: summary.total,
              },
              {
                title: "Healthy",
                value: summary.healthy,
              },
              {
                title: "Rising",
                value: summary.rising,
              },
              {
                title: "Stable",
                value: summary.stable,
              },
              {
                title: "Declining",
                value: summary.declining,
              },
              {
                title: "Dead",
                value: summary.dead,
              },
            ].map((card) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                key={card.title}
              >
                <Card>
                  <CardContent>
                    <Typography
                      color="textSecondary"
                      gutterBottom
                    >
                      {card.title}
                    </Typography>

                    <Typography variant="h4">
                      {card.value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* ========================= */}
          {/* TABLE */}
          {/* ========================= */}

          <Paper
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <TblContainer>
              <TblHead
                styles={{
                  fontSize: 11,
                  padding: 4,
                }}
              />

              <TableBody>
                {recordsAfterPagingAndSorting().map((item) => (
                  <TableRow
                    hover
                    key={item.id}
                    onClick={() =>
                      openMomentum(item.collection)
                    }
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <TableCell>
                      {item.collection}
                    </TableCell>

                    <TableCell>
                      {item.collectionStatus}
                    </TableCell>

                    <TableCell>
                      {formatNumber(
                        item.collectionSales365
                      )}
                    </TableCell>

                    <TableCell>
                      {formatRatio(
                        item.collectionMomentumRatio
                      )}
                    </TableCell>

                    <TableCell>
                      {item.heroDependency}
                    </TableCell>

                    <TableCell>
                      {item.activeSkuRatio}%
                    </TableCell>

                    <TableCell>
                      {item.totalSku}
                    </TableCell>

                    {/* <TableCell>
                      <Controls.Button
                        text="View"
                        onClick={(e) => {
                          e.stopPropagation();

                          openMomentum(
                            item.collection
                          );
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </TblContainer>

            <TblPagination />
          </Paper>
        </>
      )}      

    </Box>
  );
}